import Scrollbar from 'smooth-scrollbar'
import Snackbar from 'node-snackbar'
import Store from '../store/index'
import Route from '../router/index'
import * as $ from 'jquery'
window.$ = $
window.jQuery = $
import '../assets/js/plugins/foundation.min'
import '../assets/js/plugins/jquery.mCustomScrollbar.concat.min'
import 'jquery-match-height'
// import '../assets/js/plugins/intltelinput/intlTelInput-jquery'

export const blacktel = {
  index () {
    this.loaderInit()
    this.activeRoute()
    this.SmoothScrollbar()
    this.bodyClassCheck()
    this.topMenuBarRightMenu()
    this.fixedChatContains()
    this.matchHeight()
    // this.phoneInput()
  },
  mainIndex () {
    this.ripple()
    this.sideBarToggle()
    this.navBarAction()
    this.chat()
  },
  foundationInit(elem = undefined) {
    setTimeout(function(){
      if (elem !== undefined) {
        if ($(elem).length) {
          $(elem).foundation()
        }
      } else {
        $(document).foundation()
      }
    }, 300);
  },
  customElementReflow () {
    let obj = {
      '.entry-drop':{
        'mainAttr': 'data-toggle',
        'matchAttr':'aria-controls'
      },
      '.entry-dropdown':{
        'mainAttr': 'id',
        'matchAttr':'data-yeti-box'
      },
      '.reveal':{
        'mainAttr': 'id',
        'matchAttr':'data-yeti-box'
      },
       '.entry-delete': {
        'mainAttr': 'data-open',
        'matchAttr':'aria-controls'
      },
      '.drop-menu': {
        'mainAttr': 'data-toggle',
        'matchAttr':'aria-controls'
      }
    };
    for(var key in obj){
      window.$(document).find(key).each((index, item) => {
        if(window.$(document).find(item).attr(obj[key].mainAttr) != window.$(item).attr(obj[key].matchAttr)) {
          window.$(document).find(item).attr(obj[key].mainAttr, window.$(item).attr(obj[key].matchAttr));
        }
      });
    }
  },
  removeDuplicateElement(findKey) {
    window.currentDocumentElements = [];
    window.$(document).find(findKey).each((index, item) => {
      var elementId = $(item).attr('id');
      if($.inArray(elementId, window.currentDocumentElements) !== -1) {
        window.$('#'+elementId).detach();
      } else {
        window.currentDocumentElements.push(elementId);
      }
    });
  },
  audioInit () {
    // const players = document.querySelectorAll('.mejs__player')
    // Array.from(players, (elem) => {
    //   const player = new MediaElementPlayer(elem, {
    //     success: function(mediaElement, originalNode, instance) {
    //       // do things
    //     },
    //   });
    // })
  },
  openAudio(){
      $(document).on('click','.open-audio', function() {
        $(this).next(".audio-content").toggle();
      });
  },
  topMenuBarRightMenu () {
    $(document).on('click', function (e) {
      let myTargetElement = e.target
      let selector, mainElement
      if ($(myTargetElement).hasClass('search-toggle') || $(myTargetElement).parent().hasClass('search-toggle') || $(myTargetElement).parent().parent().hasClass('search-toggle')) {
        if ($(myTargetElement).hasClass('search-toggle')) {
          selector = $(myTargetElement).parent()
          mainElement = $(myTargetElement)
        } else if ($(myTargetElement).parent().hasClass('search-toggle')) {
          selector = $(myTargetElement).parent().parent()
          mainElement = $(myTargetElement).parent()
        } else if ($(myTargetElement).parent().parent().hasClass('search-toggle')) {
          selector = $(myTargetElement).parent().parent().parent()
          mainElement = $(myTargetElement).parent().parent()
        }
        if (!mainElement.hasClass('active') && $('.navbar-list li').find('.active')) {
          $('.navbar-list li').removeClass('iq-show')
          $('.navbar-list li .search-toggle').removeClass('active')
        }
        selector.addClass('iq-show')
        mainElement.addClass('active')
        e.preventDefault()
      } else if ($(myTargetElement).is('.search-input')) {
        // Else If Block
      } else {
        $('.navbar-list li').removeClass('iq-show')
        $('.navbar-list li .search-toggle').removeClass('active')
      }
    })
  },
  loaderInit () {
    let load = document.getElementById('loading')
    animation.fadeOut(load, { duration: 0 })
    animation.fadeOut(load, { duration: 1400 })
  },
  activeRoute () {},
  fixedChatContains () {
    $('.iq-chat-contains').scroll(function () {
      if ($(this).scrollTop()) {
        $(this).addClass('active')
      } else {
        $(this).removeClass('active')
      }
    })
  },
  ripple () {
    $(document).on('click', '.iq-waves-effect', function (e) {
      // Remove any old one
      $('.ripple').remove()
      // Setup
      let posX = $(this).offset().left
      let posY = $(this).offset().top
      let buttonWidth = $(this).width()
      let buttonHeight = $(this).height()

      // Add the element
      $(this).prepend("<span class='ripple'></span>")

      // Make it round!
      if (buttonWidth >= buttonHeight) {
        buttonHeight = buttonWidth
      } else {
        buttonWidth = buttonHeight
      }

      // Get the center of the element
      let x = e.pageX - posX - buttonWidth / 2
      let y = e.pageY - posY - buttonHeight / 2

      // Add the ripples CSS and start the animation
      $('.ripple').css({
        width: buttonWidth,
        height: buttonHeight,
        top: y + 'px',
        left: x + 'px'
      }).addClass('rippleEffect')
    })
  },
  fullscreen () {
    const elementExist = this.checkElement('class', 'iq-full-screen')
    if (elementExist) {
      $(document).on('click', '.iq-full-screen', function () {
        let elem = $(this)
        if (!document.fullscreenElement &&
          !document.mozFullScreenElement &&
          !document.webkitFullscreenElement &&
          !document.msFullscreenElement) {
          if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen()
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen()
          } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
          } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
          }
        } else {
          if (document.cancelFullScreen) {
            document.cancelFullScreen()
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen()
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
          }
        }
        elem.find('i').toggleClass('ri-fullscreen-line').toggleClass('ri-fullscreen-exit-line')
      })
    }
  },
  triggerSet () {
    const elementExist = this.checkElement('class', 'wrapper-menu')
    if (elementExist) {
      let wrapperMenu = document.querySelector('.wrapper-menu')
      let body = document.querySelector('body')
      this.sidebarMiniSetEvent(wrapperMenu, body)
      /* for (let i = 0; i < wrapperMenu.length; i++) {
      } */
    }
  },
  sidebarMiniSetEvent (element, target) {
    element.classList.toggle('open')
    target.classList.toggle('sidebar-main')
  },
  checkClass (ele, type, className) {
    switch (type) {
      case 'addClass':
        if (!ele.hasClass(className)) {
          ele.addClass(className)
        }
        break
      case 'removeClass':
        if (ele.hasClass(className)) {
          ele.removeClass(className)
        }
        break
      case 'toggleClass':
        ele.toggleClass(className)
        break
    }
  },
  sideBarToggle () {
    // eslint-disable-next-line no-unused-vars
    const elementExist = this.checkElement('class', 'iq-sidebar-menu')
    if (elementExist) {
      $(document).on('click', '.iq-sidebar-menu li', function () {

      })
    }
  },
  navBarAction () {
    $(document).on('click', '.iq-sub-dropdown', function (e) {
      e.stopPropagation()
    })
    $(document).on('click', function (e) {
      let myTargetElement = e.target
      let selector, mainElement
      if ($(myTargetElement).hasClass('search-toggle') || $(myTargetElement).parent().hasClass('search-toggle') || $(myTargetElement).parent().parent().hasClass('search-toggle')) {
        if ($(myTargetElement).hasClass('search-toggle')) {
          selector = $(myTargetElement).parent()
          mainElement = $(myTargetElement)
        } else if ($(myTargetElement).parent().hasClass('search-toggle')) {
          selector = $(myTargetElement).parent().parent()
          mainElement = $(myTargetElement).parent()
        } else if ($(myTargetElement).parent().parent().hasClass('search-toggle')) {
          selector = $(myTargetElement).parent().parent().parent()
          mainElement = $(myTargetElement).parent().parent()
        }
        if (!mainElement.hasClass('active') && $('.navbar-list li').find('.active')) {
          $('.navbar-list li').removeClass('iq-show')
          $('.navbar-list li .search-toggle').removeClass('active')
        }

        selector.toggleClass('iq-show')
        mainElement.toggleClass('active')

        e.preventDefault()
      } else if ($(myTargetElement).is('.search-input')) {
        // Else If Block
      } else {
        $('.navbar-list li').removeClass('iq-show')
        $('.navbar-list li .search-toggle').removeClass('active')
      }
    })
  },
  checkElement (type, element) {
    let found = false
    let elements
    switch (type) {
      case 'class':
        elements = document.getElementsByClassName(element)
        if (elements !== undefined && elements !== null && elements.length > 0) {
          found = true
        }
        break

      case 'id':
        elements = document.getElementById(element)

        if (elements !== undefined && elements !== null) {
          found = true
        }
        break
    }
    return found
  },
  bodyClassCheck () {
    let body = document.querySelector('body')
    body.classList.remove('message-page')
    body.classList.remove('tab-header')
    body.classList.remove('activity-page')
    body.classList.remove('calls-pages')
    body.classList.remove('fax-page')
    body.classList.remove('contact-page')
    // alert(Route.currentRoute.name)
    switch (Route.currentRoute.name) {
      case 'sign-up':
        body.classList.add('bg-primary')
        break
      case 'blacktel.sign-in':
        body.classList.add('bg-primary mb-0')
        break
      case 'signup':
        body.classList.add('bg-primary')
        break
      case 'sign-up1':
        body.classList.add('bg-primary')
        break
      case 'blacktel.sign-up1':
        body.classList.add('bg-primary')
        break
      case 'activity.recent':
        body.classList.add('contact-page')
        body.classList.add('tab-header')
        break
      case 'activity.call':
        body.classList.add('contact-page')
        body.classList.add('tab-header')
        break
      case 'activity.message':
        body.classList.add('contact-page')
        body.classList.add('tab-header')
        break
      case 'activity.fax':
        body.classList.add('contact-page')
        body.classList.add('tab-header')
        break
      case 'activity.billing':
        body.classList.add('contact-page')
        body.classList.add('tab-header')
        break
      case 'activity.information':
        body.classList.add('contact-page')
        body.classList.add('tab-header')
        break
      case 'dashboard.messages':
        body.classList.add('message-page')
        break
      case 'dashboard.calls':
        body.classList.add('contact-page')
        body.classList.add('tab-header')
        break
      case 'dashboard.faxes':
        body.classList.add('fax-page')
        break
      case 'dashboard.contacts':
        body.classList.add('contact-page')
        body.classList.add('tab-header')
        break
      case 'dashboard.numbers':
        body.classList.add('contact-page')
        body.classList.add('tab-header')
        break
      default:
        body.classList.remove('bg-primary')
        break
    }
  },
  owlCarousel () {},
  SmoothScrollbar () {
    const elementExistMain = this.checkElement('id', 'sidebar-scrollbar')
    if (elementExistMain) {
      Scrollbar.init(document.querySelector('#sidebar-scrollbar'))
    }
    const elementExistRight = this.checkElement('id', 'right-sidebar-scrollbar')
    if (elementExistRight) {
      Scrollbar.init(document.querySelector('#right-sidebar-scrollbar'))
    }
  },
  getActiveLink (item, activeRoute) {
    let active = false
    if (item.children !== undefined) {
      item.children.filter(function (child) {
        if (child.link.name === activeRoute) {
          active = true
        }
      })
    } else {
      if (item.link.name === activeRoute) {
        active = true
      }
    }
    return active
  },
  showTestSnackbar() {
    let messageUI = '<ul><li> Message 1 </li><li> Message 2 </li><li> Message 3 </li><li> Message 4 </li></ul>';
    Snackbar.show({ text: messageUI, backgroundColor: '#b21f2d', actionTextColor: '#ffffff', pos: 'top-center', showAction: true, actionText: 'X' })
  },
  showSnackbar (type, data = {}) {
    if (type !== null) {
      switch (type) {
        case 'success':
          Snackbar.show({ text: '✔ ' + data, backgroundColor: '#323232', actionTextColor: '#ffffff', pos: 'top-center', showAction: true, actionText: 'X' })
          break
        case 'error':
          if(typeof data == 'string') {
            Snackbar.show({ text: '✘ ' + data, backgroundColor: '#b21f2d', actionTextColor: '#ffffff', pos: 'top-center', showAction: true, actionText: 'X' })
          } else {
            var messageLi = '';
            // eslint-disable-next-line
            for (const [__,value] of Object.entries(data)) {
              messageLi += '<li>' + value + '</li>';
            }
            var messageUl = '<ul>'+ messageLi +'</ul>';
            Snackbar.show({ text: messageUl, backgroundColor: '#b21f2d', actionTextColor: '#ffffff', pos: 'top-center', showAction: true, actionText: 'X' })
          }
          break
      }
    } else {
      Snackbar.show(data)
    }
  },
  Snackbar (data) {
    Snackbar.show(data)
  },
  chat () {
    $('#chat-start').click(function () {
      $('.chat-data-left').toggleClass('show')
    })
    $('.close-btn-res').click(function () {
      $('.chat-data-left').removeClass('show')
    })
    $('.iq-chat-ui li').click(function () {
      $('.chat-data-left').removeClass('show')
    })
    $('.sidebar-toggle').click(function () {
      $('.chat-data-left').addClass('show')
    })
  },
  random (length) {
    let result = ''
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let charactersLength = characters.length
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  },
  applyDrag (arr, dragResult) {
    const { removedIndex, addedIndex, payload } = dragResult
    if (removedIndex === null && addedIndex === null) return arr

    const result = [...arr]
    let itemToAdd = payload

    if (removedIndex !== null) {
      itemToAdd = result.splice(removedIndex, 1)[0]
    }

    if (addedIndex !== null) {
      result.splice(addedIndex, 0, itemToAdd)
    }

    return result
  },
  generateItems (count, creator) {
    const result = []
    for (let i = 0; i < count; i++) {
      result.push(creator(i))
    }
    return result
  },
  searchAddressBookName (searchNumber) {
    if(Store.state.addressBook !== undefined  && Store.state.addressBook.length > 0) {
      let addresBook = Store.state.addressBook.find(ab => ab.number === searchNumber)
      return addresBook ? addresBook.name : searchNumber
    } else {
      return searchNumber
    }
  },
  searchvirtualNumbersName (searchNumber) {
    if(Store.state.virtualNumbers !== undefined  && Store.state.virtualNumbers.length > 0) {
      let virtualNumber = Store.state.virtualNumbers.find(ab => ab.number === searchNumber)
      return virtualNumber ? virtualNumber.name : searchNumber
    } else {
      return searchNumber
    }
  },
  searchvirtualNumber (searchNumber) {
    if(Store.state.virtualNumbers !== undefined  && Store.state.virtualNumbers.length > 0) {
      return Store.state.virtualNumbers.find(ab => ab.number === searchNumber);
    } else {
      return [];
    }
  },
  findContactName (searchNumber) {
    let addresBook = Store.state.addressBook
    let i = 0
    if (addresBook === undefined) return ''
    if (addresBook.length === 0) return ''
    for (i = 0; i < addresBook.length; i++) {
      if (addresBook[i].number === searchNumber) {
        return addresBook[i].name
      }
    }
    return ''
  },
  scrollRemoveDuplicateDate (Data) {
    let tempArr = Data
    let lastMatched = ''
    tempArr.map(obj => {
      if (obj.messageDate !== undefined && obj.messageDate !== '') {
        if (obj.messageDate === lastMatched) {
          obj.messageDate = ''
        } else {
          lastMatched = obj.messageDate
        }
      }
    })
    return tempArr
  },
  removeDuplicateObject (Data) {
    let tempArr = []
    let filterInput = Data
    for (let i = 0; i < filterInput.length; i++) {
      let matchResult = []
      matchResult = tempArr.filter((item) => {
        return (item.id === filterInput[i].id)
      })
      if (matchResult.length === 0) {
        tempArr.push(filterInput[i])
      }
    }
    return tempArr
  },
  floaterHelp(){
    $(".circle").on("click", function() {
      $('.circle a, .circle li, .circle p').click(function(e) {
        e.stopPropagation();
      });
      $(".circle").toggleClass("pill");
    });
  },
  messageListInit() {
    $(function() {
      $(".messages-list-sidebar .toggle-nav").on('click', function() {
        $(this).parent().next('.messages-list-container').toggle();
        $(this).toggleClass("is-active");
        $(this).parent().parent().toggleClass("is-open");
      });
    });
  },
  mobileView(){
    $(".mobile-nav .toggle-nav").on('click', function() {
      $(this).parent().next('.nav-items').toggle();
      $(this).toggleClass("is-active");
    });
  },
  matchHeight() {
    $(function() {
      $('.matchHeight').matchHeight();
    });
  },
  phoneInput() {
    $(function() {
      $(".phoneInput").intlTelInput({
        defaultCountry: "us",
        responsiveDropdown: true,
        utilsScript: "assets/js/plugins/intltelinput/utils.js"
      });
    });
  },
  updateCustomScrollBar() {
    if($(".customScroll").length !== undefined) {
      $(".customScroll").mCustomScrollbar("update");
    }
    if($('.messagesScroll').length !== undefined) {
      $('.messagesScroll').mCustomScrollbar('scrollTo','bottom');
    }
  },
  customScrollBar(callback = undefined){
      // ---
      // Custom Scroll - General
      // ---
      $(".customScroll").mCustomScrollbar({
        axis:"y",
        mouseWheelPixels: '175',
        scrollInertia: '0',
        theme:"dark",
        callbacks:{
          onScroll:function(){
            if(callback !== undefined) {
              callback(this.mcs)
            }
          }
        }
      });

      // ---
      // Custom Scroll - Inverted
      // ---
      $(".messagesScroll").mCustomScrollbar({
        axis:"y",
        mouseWheelPixels: '100',
        scrollInertia: "0",
        setTop:"9999px",
        theme:"dark",
        advanced:{updateOnContentResize:true},
        callbacks:{
          onTotalScrollBack:function(){
          },
          onScroll: function() {
            if(callback !== undefined) {
              callback(this.mcs)
            }
          },
          onTotalScrollBackOffset:100,
          //alwaysTriggerOffsets:false
        },
      });
      //$('.messagesScroll').mCustomScrollbar('scrollTo','bottom');
  },

}

export const animation = {
  easing: {
    linear: function (progress) {
      return progress
    },
    quadratic: function (progress) {
      return Math.pow(progress, 2)
    },
    swing: function (progress) {
      return 0.5 - Math.cos(progress * Math.PI) / 2
    },
    circ: function (progress) {
      return 1 - Math.sin(Math.acos(progress))
    },
    back: function (progress, x) {
      return Math.pow(progress, 2) * ((x + 1) * progress - x)
    },
    elastic: function (progress, x) {
      return Math.pow(2, 10 * (progress - 1)) * Math.cos(20 * Math.PI * x / 3 * progress)
    }
  },
  animate: function (options) {
    let start = new Date()
    let id = setInterval(function () {
      let timePassed = new Date() - start
      let progress = timePassed / options.duration
      if (progress > 1) {
        progress = 1
      }
      options.progress = progress
      let delta = options.delta(progress)
      options.step(delta)
      if (progress === 1) {
        clearInterval(id)
      }
    }, options.delay || 10)
  },
  fadeOut: function (element, options) {
    this.animate({
      duration: options.duration,
      delta: function (progress) {
        progress = this.progress
        return animation.easing.swing(progress)
      },
      step: function () {
      }
    })
  }
}

export const flatpickerSetting = {
  wrap: true,
  altFormat: 'j M Y',
  altInput: true,
  dateFormat: 'Y-m-d'
}
